import React from 'react';
import parts from '../moduleCard/moduleParts.module.css';
import styles from './scales.module.css';
import ScaleOptionGrid from './ScaleOptionGrid';
import { dualDifference, toggleDualAnswer } from '../../modules/scales/scaleValues';

/**
 * Duas respostas sobre as mesmas opções (ex.: "Como se vê" e "Como gostaria
 * de ser"), cada uma com seus cards, e a diferença entre elas logo abaixo.
 */
const ScaleDualChoice = ({ scale, value, onChange, readOnly, gender }) => {
  const answers = (value && value.answers) || {};
  const difference = dualDifference(scale, value);

  return (
    <>
      {(scale.answers || []).map((answer) => (
        <div key={answer.key} className={styles.answer}>
          <span className={parts.sectionLabel}>{answer.label}</span>
          <ScaleOptionGrid
            options={scale.options}
            selected={answers[answer.key] ? [answers[answer.key]] : []}
            onToggle={(optionValue) => onChange(toggleDualAnswer(value, answer.key, optionValue))}
            readOnly={readOnly}
            gender={gender}
          />
        </div>
      ))}
      {difference && (
        <span className={`${parts.chip} ${parts.chipAccent} ${styles.difference}`}>Diferença: {difference.text}</span>
      )}
    </>
  );
};

export default ScaleDualChoice;
